import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import gql from "graphql-tag";
import { Promotion, PromotionType, ShopType } from "src/types/graphql.d";

export const GET_PROMOTION = gql`
  query promotion(
    $slug: String!
    $type: PromotionType!
    $shop_type: ShopType!
  ) {
    promotion(slug: $slug, type: $type, shop_type: $shop_type) {
      promo_code
      promo_image_desktop
      promo_image_mobile
      promo_message
      promo_message_url
      promo_name
      promo_url_kids
      promo_url_men
      promo_url_women
      promo_start_date
      promo_end_date
      promo_display_type
      promo_background_color
      promo_text_color
      promo_highlight_color
    }
  }
`;

interface PromotionVars {
  slug: string;
  type: PromotionType;
  shop_type: ShopType;
}

export interface PromotionData {
  promotion: Promotion;
}

type UsePromotionProps = {
  loading: boolean;
  error: ApolloError | undefined;
  data: PromotionData | undefined;
};

const usePromotion = (
  slug: string,
  type: PromotionType,
  shop_type: ShopType,
  skip?: boolean
): UsePromotionProps => {
  const { loading, error, data } = useQuery<PromotionData, PromotionVars>(
    GET_PROMOTION,
    {
      variables: { slug, type, shop_type },
      fetchPolicy: "cache-first",
      skip: skip || !shop_type || !slug,
    }
  );

  return { loading, error, data };
};

export { usePromotion };
